export enum TranslationLocale {
  FR = 'FR',
  EN = 'EN',
  ES = 'ES',
  DE = 'DE'
}

export const TRANSLATION_LOCALES: TranslationLocale[] = [
  TranslationLocale.FR,
  TranslationLocale.EN,
  TranslationLocale.ES,
  TranslationLocale.DE
]
